import Service from "../../../Services/index";

const holiday = {
    namespaced: true,
    state: {
        holidayList: [],
        holidayForm: {
            id: "",
            name: "",
            start_date: "",
            user_id: "",
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        }
    },
    mutations: {
        GET_HOLIDAY_LIST: (state, res) => {
            state.holidayList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.total
            }
        },
        GET_HOLIDAY_BY_ID: (state, res) => {
            state.holidayForm = res;
        },
        CLEAR_DATA_FORM: state => {
            state.holidayForm = {
                id: "",
                name: "",
                start_date: "",
                user_id: "",
            };
        }
    },
    actions: {
        setHoliday({commit}, page = 1) {
            return Service.Holiday.getHoliday(page).then(response => {
                commit("GET_HOLIDAY_LIST", response);
            });
        },
        showHolidayById({commit}, id) {
            return Service.Holiday.showHoliday(id).then(response => {
                commit("GET_HOLIDAY_BY_ID", response);
            });
        },
        saveHoliday({state}, id) {
            let data = {
                name: state.holidayForm.name,
                start_date: state.holidayForm.start_date,
                user_id: state.holidayForm.user_id,
            };
            // //console.log(data);
            if (!id) {
                return Service.Holiday.createHoliday(data).then(res => {
                    // //console.log(res);
                });
            } else {
                return Service.Holiday.updateHoliday(id, data).then(res => {
                    // //console.log(res);
                });
            }
        },
        deleteHoliday({commit}, id) {
            return Service.Holiday.deleteHoliday(id);
        },
        clearData({commit}) {
            commit("CLEAR_DATA_FORM");
        },
        search({commit}, data) {
            return Service.Holiday.searchHoliday(data).then(res => {
                commit("GET_HOLIDAY_LIST", res);
            })
        }
    }
};
export default holiday;
